import { Link } from 'react-router-dom';
import { Typography } from './Typography';

/**
 * The 404 page, shared by both portals — reached via `ERoute.Error` (`/error`) in each.
 *
 * The two apps carried identical copies of this (byte-identical once comments were
 * stripped), which is why it lives here now. It is presentation only: no data access, no
 * portal-specific behaviour, nothing to parameterise.
 *
 * Not ported from the legacy `screens/Error/Error.tsx`:
 * - The inline ~60-line Vuexy brand-logo SVG and the "Vuexy" wordmark beside it
 *   (untouched template branding, not RealtyFeed's).
 * - The `error.svg` / `error-dark.svg` illustration chosen by `useSkin()`. Those assets
 *   were not brought into `libs/shared/assets` in the migration, and `useSkin` carries a
 *   body-classList side effect intended to run once at the root layout, not per page —
 *   dark/light is handled by Tailwind `dark:` variants instead. Both portals' ported
 *   pages made the same call, so both 404s already matched.
 * - `@styles/base/pages/page-misc.scss` and its `misc-wrapper`/`misc-inner` Bootstrap
 *   classes.
 *
 * Copy is preserved, minus the source's trailing emoji ("Page Not Found 🕵🏻‍♀️",
 * "Oops! 😖 ..."), which both portals had already dropped.
 */
export function ErrorPage() {
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center gap-4 text-center">
      <Typography as="h2" size="3xl" weight="bold" className="text-slate-950 dark:text-slate-50">
        Page Not Found
      </Typography>
      <Typography as="p" size="base" className="max-w-md text-slate-600 dark:text-slate-400">
        Oops! The requested URL was not found on this server.
      </Typography>
      <Link
        to="/"
        className="inline-flex items-center justify-center rounded-lg bg-cyan-500 px-4 py-2 text-sm font-semibold text-slate-950 hover:bg-cyan-400"
      >
        Back to home
      </Link>
    </div>
  );
}
